export default "__VITE_ASSET__4a56858e__"